const CustomizeInfo = () => (
    <div className={'border-top  border-dark-subtle  mt-4  pt-3  fs-8'}>
        <p className={'mb-2  fw-semibold'}>{'Infos zum Datenupload'}</p>
        <a href={'/pdf/leitfaden_druckdatenanlage.pdf'} target={'_blank'} className={'d-block  text-decoration-underline  fs-9'}>{'Anleitung zur Druckdatenerstellung'}</a>
    </div>
)

export default CustomizeInfo
